"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = void 0;
var _react = require("react");
var _Snackbar = _interopRequireDefault(require("./Snackbar.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Snackbar = props => {
  const {
    contentText,
    zIndex,
    timeout,
    onTimeout
  } = props;
  const [isHidden, setIsHidden] = (0, _react.useState)(false);
  const styles = (0, _Snackbar.default)(isHidden, zIndex);
  (0, _react.useEffect)(() => {
    let timer;
    let startTimer = timeout && timeout > 0 && contentText;
    setIsHidden(!startTimer);
    if (startTimer) {
      timer = setTimeout(() => {
        setIsHidden(true);
        if (onTimeout) {
          onTimeout();
        }
      }, timeout);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [contentText, onTimeout, timeout]);
  const ariaLiveValue = isHidden ? 'off' : 'assertive';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Snackbar'],
    role: "alert",
    "aria-live": ariaLiveValue,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: contentText
    })
  });
};
exports.Snackbar = Snackbar;